var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 68.6 49.285714",
    id: "svg64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title59"
  }, "19081BA0-B8C7-4124-BCCB-CE4B60A6C2E2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title59"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hub-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(90,31.961983,36.290742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-Arrow---Hub",
    fill: "#14405c",
    stroke: "#ffffff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 23.912702,17.458917 c 0.883028,-0.150302 1.823394,0.03626 2.611799,0.595309 0.321665,0.228091 0.602474,0.508899 0.830564,0.830565 v 0 l 22.426469,31.627072 c 0.559051,0.788404 0.745612,1.728771 0.595309,2.611798 -0.150302,0.883028 -0.637469,1.708717 -1.425873,2.267768 -0.5917,0.419569 -1.299141,0.644935 -2.024501,0.644935 v 0 H 2.0735307 c -0.9664983,0 -1.84149832,-0.391751 -2.47487374,-1.025127 -0.63337546,-0.633375 -1.02512626,-1.508375 -1.02512626,-2.474873 0,-0.72536 0.225366,-1.432801 0.64493487,-2.024501 v 0 L 21.644935,18.884791 c 0.55905,-0.788405 1.384739,-1.275571 2.267767,-1.425874 z",
    id: "Triangle",
    transform: "rotate(90,24.5,34.536364)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.406793707fba8285321ae5cc98de5b2c.svg";
export { ForwardRef as ReactComponent };